import React from 'react'
import moment from 'moment'

const initialState = {
  fetchedAt: '',
}

export const usePlanBillingContext = () => {
  const context = React.useContext(PlanBillingContext)
  if (context === undefined) {
    throw new Error(
      'usePlanBillingContext must be used within a PlanBillingProvider',
    )
  }
  return context
}

export const PlanBillingProvider = ({ children }) => {
  const [state, setState] = React.useState(initialState)
  const refetch = () => {
    setState({ fetchedAt: moment() })
  }
  return (
    <PlanBillingContext.Provider value={{ state, refetch }}>
      {children}
    </PlanBillingContext.Provider>
  )
}

export const PlanBillingContext = React.createContext()
